import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '@/context/TranslationContext';
import { MemberCounterInline } from '@/components/landing/MemberCounter';

/** Public routes that have no footer of their own (Landing + PublicPageLayout pages carry the counter in their footers). */
const STRIP_PATHS = ['/pricing', '/values', '/legal', '/privacy', '/contact', '/practitioners', '/community-dashboard', '/clips'];

export function PublicFooterStrip() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (!STRIP_PATHS.includes(pathname)) return null;
  return (
    <footer className="border-t border-[var(--border)] px-6 md:px-12 py-5" style={{ backgroundColor: 'var(--bg-primary)' }} data-testid="public-footer-strip" role="contentinfo">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-between gap-3">
        <MemberCounterInline />
        <nav className="flex items-center gap-4 text-xs text-[var(--text-secondary)]" aria-label="Footer">
          <Link to="/" className="hover:text-[var(--text-primary)]" data-testid="strip-home-link">{t('Home')}</Link>
          <Link to="/about" className="hover:text-[var(--text-primary)]" data-testid="strip-about-link">{t('About')}</Link>
          <Link to="/trust-safety" className="hover:text-[var(--text-primary)]" data-testid="strip-trust-link">{t('Trust & Safety')}</Link>
          <Link to="/values" className="text-[var(--accent)] hover:underline" data-testid="strip-join-link">{t('Join free')}</Link>
        </nav>
      </div>
    </footer>
  );
}
